"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GateFromIngredient = void 0;
const AbstractIngredient_1 = require("./AbstractIngredient");
const java_object_serialization_1 = require("java-object-serialization");
const SerializeReadHelper_1 = require("./SerializeReadHelper");
class From {
    constructor() {
        this.value = 0;
    }
    readObject(stream) {
        const reader = new SerializeReadHelper_1.SerializeReadHelper(stream);
        const version = reader.readStringObject();
        if (version !== "V1-20020725") {
            throw new Error("bad From version");
        }
        this.value = reader.readShort();
        if (!reader.isReadAndCheckCrcOk()) {
            throw new Error("From data is corrupted");
        }
    }
    // Mirror-ish the Java version, which returns a singleton object for each value.
    readResolve() {
        switch (this.value) {
            case 1:
                return "SET_VALUE";
            case 2:
                return "MULTI_A";
            case 3:
                return "ADV_P";
            default:
                throw new Error("invalid From");
        }
    }
}
java_object_serialization_1.ObjectInputStream.RegisterObjectClass(From, "com.erostek.eroslink.GateFromIngredient$From", "13441635889020800604");
class GateFromIngredient extends AbstractIngredient_1.AbstractIngredient {
    constructor() {
        super(...arguments);
        this.onFrom = "SET_VALUE";
        this.offFrom = "SET_VALUE";
    }
    readObject(stream) {
        const reader = new SerializeReadHelper_1.SerializeReadHelper(stream);
        const version = reader.readStringObject();
        if (version !== "V1-20020718") {
            throw new Error("bad GateFromIngredient version");
        }
        this.onFrom = reader.readObject();
        this.offFrom = reader.readObject();
        if (!reader.isReadAndCheckCrcOk()) {
            throw new Error("GateFromIngredient data is corrupted");
        }
    }
}
exports.GateFromIngredient = GateFromIngredient;
java_object_serialization_1.ObjectInputStream.RegisterObjectClass(GateFromIngredient, "com.erostek.eroslink.GateFromIngredient", "1617202387615904078");
